import InfoItem from "@/components/application/InfoItem";
import { ApproveRegistration } from "@/services/application.service";
import { Button, Grid, message, Modal, Typography } from "antd";
import { Check } from "lucide-react";
import { useState } from "react";

interface AcceptApplicationModalProps {
  open: boolean;
  registrationId: string;
  name: string;
  onClose: () => void;
  onBack: () => void;
  onConfirm: () => void;
  onSuccess?: () => void;
}

const { Title } = Typography;
const { useBreakpoint } = Grid;

const modalStyles = {
  container: { padding: 0 },
  header: { padding: 0, marginBottom: 0 },
  body: { padding: 24 },
  footer: { padding: "0 16px 16px" },
} as const;

export function AcceptApplicationModal({
  open,
  registrationId,
  name,
  onClose,
  onBack,
  onConfirm,
  onSuccess,
}: AcceptApplicationModalProps) {
  const screens = useBreakpoint();
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!registrationId) {
      message.error("Registration ID tidak dijumpai.");
      return;
    }

    try {
      setLoading(true);

      await ApproveRegistration({
        registrationId,
        reason: "",
      });

      onConfirm();
      onSuccess?.();
    } catch (error) {
      console.error("Approve registration error:", error);

      message.error(
        error instanceof Error ? error.message : "Gagal menerima permohonan.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <div className="flex items-center justify-between p-4 sm:p-6 bg-[#E5F2FF] rounded-tl-2xl rounded-tr-2xl">
          <Title
            level={2}
            style={{ margin: 0, fontSize: screens.xs ? "18px" : "22px" }}
          >
            Terima
          </Title>
        </div>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      styles={modalStyles}
      width={1200}
      centered
    >
      <Title
        level={2}
        style={{
          textAlign: "center",
          fontSize: screens.xs ? 18 : 24,
          fontWeight: 700,
          marginBottom: 40,
        }}
      >
        Adakah anda pasti ingin <span className="text-[#1F993B]">menerima</span>{" "}
        permohonan ini?
      </Title>

      <div className="mb-8">
        <InfoItem label="Nama" value={name} />
      </div>

      <div className="grid grid-cols-2 gap-6 sm:gap-10">
        <Button
          color="default"
          variant="solid"
          size="large"
          onClick={onBack}
          className="w-full"
        >
          Kembali
        </Button>

        <Button
          type="primary"
          size="large"
          className="w-full"
          icon={<Check size={18} aria-hidden="true" strokeWidth={2.5} />}
          onClick={handleConfirm}
          loading={loading}
        >
          Terima
        </Button>
      </div>
    </Modal>
  );
}
